/**
 * Formats an event's location information for Google calendar.
 *
 * @example
 * fnFormatLocationForGoogleCalendar({
 *  NAME: 'Reynolda Hall',
 *  ROOM: 'Magnolia Room',
 *  ADDRESSBLOCK: '1834 Wake Forest Road',
 *  CITY: 'Winston-Salem',
 *  POSTCODE: '12345',
 *  STATE: 'NC',
 * })
 * // 'Reynolda Hall, Magnolia Room, 1834 Wake Forest Road, Winston-Salem, NC 12345'
 *
 * @param {object} oLocation - LOCATION object from the event details API response
 * @returns {string}
 */
const fnFormatLocationForGoogleCalendar = (oLocation) => {
  let sLocation = '';
  if (oLocation) {
    const { NAME, ROOM, ADDRESSBLOCK, CITY, STATE, POSTCODE } = oLocation;
    const aLocationParts = [NAME, ROOM, ADDRESSBLOCK, CITY, STATE];
    const aDefinedLocationParts = aLocationParts.filter((mItem) => !!mItem);
    sLocation = aDefinedLocationParts.join(', ');
    if (POSTCODE) {
      sLocation += ` ${POSTCODE}`;
    }
  }
  return sLocation;
};

export default fnFormatLocationForGoogleCalendar;
